import { render, staticRenderFns } from "./ContactMoneyOrders.vue?vue&type=template&id=5743672e&scoped=true"
import script from "./ContactMoneyOrders.vue?vue&type=script&lang=js"
export * from "./ContactMoneyOrders.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyOrders.vue?vue&type=style&index=0&id=5743672e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5743672e",
  null
  
)

export default component.exports